import { render, staticRenderFns } from "./LenderAboutYou.vue?vue&type=template&id=e22e2248&scoped=true"
import script from "./LenderAboutYou.vue?vue&type=script&lang=js"
export * from "./LenderAboutYou.vue?vue&type=script&lang=js"
import style0 from "./LenderAboutYou.vue?vue&type=style&index=0&id=e22e2248&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e22e2248",
  null
  
)

export default component.exports